// extracted by mini-css-extract-plugin
export default {"modalOverlay":"VI-z","modalContent":"WI-z","header":"XI-z","close":"YI-z"};